import React from 'react';

import * as Types from 'types';

import { EditionDetailsPrimaryContent } from 'editions/EditionDetails/EditionDetailsPrimaryContent';
import { ActionButton } from 'components/UI/ActionButton';

type Props = {
  edition: Types.EditionWithArtwork;
  onDownloadClick: () => void;
  onGiftClick: () => void;
  onMintClick: () => void;
  onRequestClose: () => void;
};

export const EditionDetailsContent: React.FC<Props> = ({
  edition,
  onDownloadClick,
  onGiftClick,
  onMintClick,
  onRequestClose,
}) => (
  <div className='edition-details__content'>
    <EditionDetailsPrimaryContent edition={edition} />
    <div className='edition-details__secondary-content'>
      <div className='mb-3 mb-md-0'>
        <ActionButton handleClick={onDownloadClick} icon='download' label='Download Wallpaper' />
        {edition.artwork.giftable && (
          <ActionButton handleClick={onGiftClick} icon='gift' label='Send as Gift' />
        )}
      </div>
      <div className='w-100' style={{ alignSelf: 'flex-end' }}>
        {edition.artwork.nft && (
          <button className='btn btn--bg-dark btn--lg w-100 mb-mini fw-500' onClick={onMintClick}>
            {edition.certificate.ownerAddress ? 'View NFT' : 'Mint NFT'}
          </button>
        )}
        <button className='btn btn--lg btn--border-dark w-100 ml-0' onClick={onRequestClose}>
          Close
        </button>
      </div>
    </div>
  </div>
);
